import PropTypes from 'prop-types'

import AtomCheckbox from '@s-ui/react-atom-checkbox'
import CheckboxUnchecked from '@adv-mt/mt-svg-icons/lib/CheckboxEmpty.js'
import CheckboxChecked from '@adv-mt/mt-svg-icons/lib/CheckboxFilled.js'
import IconIndeterminate from '@adv-mt/mt-svg-icons/lib/CheckboxIntermediate.js'

const FilterItemBasicCheckbox = ({id, isChecked, isIndeterminate, onChange}) => (
  <AtomCheckbox
    checked={isChecked && !isIndeterminate}
    checkedIcon={CheckboxChecked}
    disabled={isIndeterminate}
    id={id}
    indeterminate={isIndeterminate}
    indeterminateIcon={IconIndeterminate}
    name={id}
    onChange={onChange}
    uncheckedIcon={CheckboxUnchecked}
  />
)

FilterItemBasicCheckbox.displayName = 'FilterItemBasicCheckbox'
FilterItemBasicCheckbox.propTypes = {
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  isIndeterminate: PropTypes.bool,
  onChange: PropTypes.func
}

export default FilterItemBasicCheckbox
